import {
    VerticalBarChart,
    VerticalBarChartDataPoint,
} from '@fluentui/react-charts';
import MetricsTile, {
    MetricsTileComponent,
} from '../core/MetricsTile/MetricsTile';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ReportingMetricsCounts } from '../../../../../../model/ReportingMetrics';
import { useAppDispatch, useSelector } from '../../../../../../store/hooks';
import { updateFilters } from '../../../../../../store/features/reportingDashboard/reportingDashboardSlice';
import { useTableChart } from '../core/TableChart/chartUtils';
import TableChart from '../core/TableChart/TableChart';

export interface AircraftRegNumbersChartTileProps {
    currentItems: ReportingMetricsCounts;
}

const Chart: React.FC<{
    items: ReportingMetricsCounts;
}> = ({ items }) => {
    const { t } = useTranslation();

    const dispatch = useAppDispatch();

    const { tableData, chartData } = useTableChart(
        items,
        useCallback(
            (sortedItems) =>
                sortedItems.map<VerticalBarChartDataPoint>((x) => {
                    return {
                        x: x.key,
                        y: x.value,
                        legend: x.label,
                        color: x.color,
                    };
                }),
            []
        )
    );

    return (
        <TableChart
            chart={
                <VerticalBarChart data={chartData} hideLegend barWidth="auto" />
            }
            tableProps={{
                rows: tableData,
                keyLabel: t('ReportingDashboard_AircraftRegNumber'),
                valueLabel: t('ReportingDashboard_ConversationCount'),
                onRowClick: (item) => {
                    if (item.key) {
                        dispatch(
                            updateFilters({ aircraftRegNumber: item.key })
                        );
                    }
                },
            }}
        />
    );
};

const AircraftRegNumbersChartTile: MetricsTileComponent<
    AircraftRegNumbersChartTileProps
> = ({ currentItems, title, className }) => {
    const { aircraftRegNumber } = useSelector(
        (x) => x.reportingDashboard.filters
    );

    const dispatch = useAppDispatch();

    return (
        <MetricsTile
            title={title}
            currentRangeItem={
                !!Object.keys(currentItems).length ? (
                    <Chart items={currentItems} />
                ) : undefined
            }
            hidePreviousRange
            filter={{
                value: aircraftRegNumber,
                clear: () =>
                    dispatch(updateFilters({ aircraftRegNumber: null })),
            }}
            className={className}
        />
    );
};

export default AircraftRegNumbersChartTile;
